
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dining-room-design-app",
      function () {
        return require("private-next-pages/dining-room-design-app.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dining-room-design-app"])
      });
    }
  